import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const wechselrichterReducer = (state = {
    WechselrichterUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_WechselrichterClass_wechselrichterReducer":
            return { ...state, WechselrichterUI: action.value, isLoaded: true };

        case requestTypes.requestStartType.type:
            return { ...state, WechselrichterUI: [], isLoaded: false };

        default:
            return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
    }
};
export default wechselrichterReducer;
